import { VF_SUB_SECTION_TITLE } from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';

const fieldId = 'post-change-questionnaire';

const validator = () => null;

const vFParams = {
  fieldTitle: 'Post Change Questionnaire',
};

const postChangeQuestionnaire = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_SUB_SECTION_TITLE,
};

export { postChangeQuestionnaire };
